import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { MainContext } from "../../../../../../Context/MainCtx";
import { useMutation } from "@apollo/client";
import { CircularProgress, IconButton } from "@mui/material";
import { TratosContext } from "../../../Context/TratosContext";
import { ELIMINAR_TRATO } from "../../../graphql/mutations";

export default function EliminarTratoOption({ trato, externalClose }) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { snackMessage } = React.useContext(MainContext);
  const { queryRefetch } = React.useContext(TratosContext);
  const [eliminarTrato] = useMutation(ELIMINAR_TRATO);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (e) => {
    setOpen(false);
    if (externalClose) externalClose(e);
  };

  const handleDeleteTrato = async (e) => {
    try {
      handleClose(e);
      setLoading(true);
      const res = await eliminarTrato({
        variables: {
          idtrato: trato._id,
        },
      });
      snackMessage({
        message: res.data.eliminarTrato.message,
        variant: "success",
      });
      queryRefetch();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <div>
      <IconButton onClick={() => handleClickOpen()}>
        <DeleteOutline fontSize="small" />
      </IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{`Eliminar ${trato.nombreTrato}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Se va a eliminar este elemento, ¿Quiere continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus color="inherit">
            No, cancelar
          </Button>
          <Button
            onClick={(e) => handleDeleteTrato(e)}
            color="error"
            variant="contained"
            disableElevation
            startIcon={
              loading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <DeleteOutline fontSize="small" />
              )
            }
          >
            Si, eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
